export const apiNewsletter = {
	newsletterSignup: async (email: string) => {
		const { data } = await apiCommon<string>('newsletter-signup', { method: 'POST', body: { email } })
		return data
	},
}
